import types from '../types'
import { getInitialUserCurrencyCode } from 'common/utils/context.js'
import { toObj } from 'common/utils/arrayUtils'
import { getInitialLanguageCode } from 'common/utils/context'

const initialState = {
  currency: getInitialUserCurrencyCode(),
  baseCurrency: '',
  currencyTypes: {},
  featuredCurrencies: [],
  languageCode: getInitialLanguageCode(),
  lastTicketSearchTimestamp: Date.now(),
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CURRENCY_CHANGED:
      return {
        ...state,
        currency: action.payload,
      }
    case types.LANGUAGE_CHANGED:
      return {
        ...state,
        languageCode: action.payload,
      }
    case types.CURRENCY_DATA_RECEIVED:
      return {
        ...state,
        baseCurrency: action.payload.baseCurrency,
        currencyTypes: toObj(action.payload.currencies, (currency) => currency.id),
        featuredCurrencies: action.payload.featuredCurrencies,
      }
    case types.RESPONSE_ADD:
    case types.RESPONSE_REPLACE:
    case types.RESPONSE_REPLACE_ALL:
      return {
        ...state,
        lastTicketSearchTimestamp: Date.now(),
      }
    default:
      return state
  }
}

export default userReducer
